import { apiClient } from './client.tsx';
import { ParkingBillingSettingRequest } from './requests/parking-billing-setting-request.ts';

export const fetchParkingBillingSettings = () =>
  apiClient
    .get('/maas_billing/parking_billing_settings?type=STANDARD_PARKING_BILLING')
    .then((res) => res.data.data);

export const fetchParkingBillingSetting = (id: string) =>
  apiClient
    .get(`/maas_billing/parking_billing_settings/${id}`)
    .then((res) => res.data.data);

export const createParkingBillingSetting = (
  data: ParkingBillingSettingRequest,
) =>
  apiClient
    .post('/maas_billing/parking_billing_settings', data)
    .then((res) => res.data.data);

export const updateParkingBillingSetting = (
  id: string,
  data: ParkingBillingSettingRequest,
) =>
  apiClient
    .patch(`/maas_billing/parking_billing_settings/${id}`, data)
    .then((res) => res.data.data);

export const voidParkingBillingSetting = (id: string) =>
  apiClient
    .delete(`/maas_billing/parking_billing_settings/${id}`)
    .then((res) => res.data.data);

export const launchParkingBillingSetting = async (
  id: string,
  offset: number,
  accountantIds: string[],
) => {
  return apiClient
    .post(`/maas_billing/parking_billing_settings/${id}/launch`, {
      offset,
      accountantIds,
    })
    .then((res) => res.data.data);
};
